import { SlidersHorizontal } from 'lucide-react';
import type { PanelSpan } from '@/components/shared';
import type { BackofficeProjectDetail } from '../types';
import { formatProductLine } from '../format';
import { ProjectDetailPanel } from './ProjectDetailPanelGrid';

export interface ProjectProductLinePanelProps {
  project: BackofficeProjectDetail;
  currentSpan: PanelSpan;
  onEdit: () => void;
}

export function ProjectProductLinePanel({
  project,
  currentSpan,
  onEdit,
}: ProjectProductLinePanelProps) {
  return (
    <ProjectDetailPanel
      title="Study's product line"
      panelId="study-product-line"
      span="1x1"
      currentSpan={currentSpan}
      headerActions={
        !project.deletedAt ? (
          <button
            type="button"
            aria-label="Change product line"
            title="Change product line"
            className="focus-ring inline-flex h-8 w-8 items-center justify-center rounded-md text-neutral-400 transition hover:bg-backoffice-50 hover:text-neutral-700"
            onClick={onEdit}
          >
            <SlidersHorizontal className="h-4 w-4" aria-hidden="true" />
          </button>
        ) : undefined
      }
    >
      <div className="flex h-full items-center justify-center text-center">
        <p className="text-title font-semibold text-neutral-900">
          {formatProductLine(project.productLine)}
        </p>
      </div>
    </ProjectDetailPanel>
  );
}
